export default __webpack_public_path__ + "static/media/trustedby4.8fe86de0.svg";